import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

export function GlobalTooltip() {
  const [tooltip, setTooltip] = useState<{ text: string; x: number; y: number; isBottom: boolean } | null>(null);

  useEffect(() => {
    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      // Encontrar el elemento más cercano que tenga title
      const elementWithTitle = target.closest('[title]:not([title=""])') as HTMLElement;
      
      if (elementWithTitle) {
        const titleText = elementWithTitle.getAttribute('title');
        if (titleText) {
          // Movemos el title a un atributo de datos para que el navegador no muestre el suyo
          elementWithTitle.setAttribute('data-global-tooltip', titleText);
          elementWithTitle.removeAttribute('title');
        }
      }
      
      // Buscar si estamos sobre un elemento que ya tiene nuestro data-tooltip
      const tooltipElement = target.closest('[data-global-tooltip]') as HTMLElement;
      if (tooltipElement) {
        const text = tooltipElement.getAttribute('data-global-tooltip');
        if (text) {
          const rect = tooltipElement.getBoundingClientRect();
          const isBottom = rect.top < 35; // Si está muy cerca del borde superior, mostramos por debajo
          
          setTooltip({
            text,
            x: rect.left + rect.width / 2,
            y: isBottom ? rect.bottom + 6 : rect.top - 6,
            isBottom,
          });
        }
      } else {
        setTooltip(null);
      }
    };

    const handleMouseOut = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const tooltipElement = target.closest('[data-global-tooltip]') as HTMLElement;
      
      if (tooltipElement) {
        setTooltip(null);
      }
    };
    
    const handleScroll = () => {
        setTooltip(null); // Esconder al scrollear para evitar tooltips flotando
    };

    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);
    document.addEventListener('scroll', handleScroll, true);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  if (!tooltip) return null;

  return createPortal(
    <div
      className="fixed z-[9999] pointer-events-none transition-all duration-75 ease-out"
      style={{
        left: tooltip.x,
        top: tooltip.y,
        transform: tooltip.isBottom ? 'translate(-50%, 0)' : 'translate(-50%, -100%)',
      }}
    >
      <div className="bg-slate-800 text-slate-50 px-2 py-1 text-[11px] font-medium rounded-md shadow-md animate-in fade-in-0 zoom-in-95 relative text-center max-w-[200px] text-balance">
        {tooltip.text}
        {/* Flecha dinámica */}
        <div 
            className="absolute left-1/2 w-2.5 h-2.5 bg-slate-800 rounded-[2px]" 
            style={{
                [tooltip.isBottom ? 'top' : 'bottom']: 0,
                transform: `translate(-50%, ${tooltip.isBottom ? '-50%' : '50%'}) rotate(45deg)`
            }}
        />
      </div>
    </div>,
    document.body
  );
}
